export class OrganisationPermission {
  organisation_id: number;
  deactivated_at?: string;
  employee_write?: boolean;
  bid_read?: boolean;
  bid_write?: boolean;

  constructor(data: any) {
    this.organisation_id = data.organisation_id;
    this.deactivated_at = data.deactivated_at;
    this.employee_write = data.employee_write ?? false;
    this.bid_read = data.bid_read ?? false;
    this.bid_write = data.bid_write ?? false;
  }

  isActive(): boolean {
    return !this.deactivated_at;
  }

  canWriteBid(): boolean {
    return this.isActive() && (this.bid_write ?? false);
  }

  canReadBid(): boolean {
    return this.isActive() && (this.bid_read ?? false);
  }

  canWriteEmployee(): boolean {
    return this.isActive() && (this.employee_write ?? false);
  }

  static build(data: any): OrganisationPermission {
    return new OrganisationPermission(data);
  }
}
